import React from 'react';

const NotFound = () => {
    return (
        <div >
            <img src="https://www.uidownload.com/files/478/82/442/error-404-page-not-found-icon.jpg" alt="" />
        </div>
    );
};

export default NotFound;